<template>
  <div id="app">
    <!-- <router-link to='/'><button>首页</button></router-link>
    <router-link to='/login'><button>登录</button></router-link> -->
    <div class="appInner" :style="{height:isShow?'':'100%'}">
      <router-view></router-view>
    </div>
    <!-- 底部 -->
    <Footer v-show="isShow"></Footer>
  </div>
</template>
<script>
import Footer from "@/components/menu/footer.vue";

export default {
  data(){
    return{
      isShow:true
    }
  },
  components: {
    Footer
  },
  watch:{
    '$route':{
      immediate:true, // 首次加载的时候执行函数
     deep:true, // 深入观察,监听数组值，对象属性值的变化
     handler:function(newVal,oldVal){
       if(newVal.meta.showFoot==false){
         this.isShow = false
       }else{
         this.isShow = true
       }
     }
    }
  }
}
</script>

<style >
  *{
    padding:0;
    margin:0;
    list-style: none;
    font-family: '微软雅黑';
  }

  #app{
    width: 100%;
    height: 100%;
  }
  /* img{
    width: 100%;
    height: 100%;
  } */
  ul{
    margin:0!important;
  }
  .appInner{
    min-width: 1300px;
    margin:0 auto;
    min-height: 400px;
  }
</style>
